module.exports = __webpack_public_path__ + "static/media/dominik-duka-parte.1223de0e.webp";